export const isEmptyObject = (obj) =>
    obj === null || Object.keys(obj).length === 0;

export const trimObjectValues = (obj) => {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [
            key,
            typeof value === 'string' ? value.trim() : value,
        ])
    );
};

export const isValidLowerCaseEmailStrict = (email) => {
    const REGEX =
        /^([a-z0-9_%+-]+(?:\.[a-z0-9_%+-]+)*)@([a-z0-9-]+\.)+[a-z]{2,}$/;
    return REGEX.test(email);
};

export const downloadCSV = (rows, fileName) => {
    const csvContent = rows.map((row) => row.join(',')).join('\n');

    const blob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;',
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const downloadCSVFromTextData = (data, fileName) => {
    const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName); // filename
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export const convertSecondsToTimeStamp = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const remainingSeconds = seconds % 3600;
    const minutes = Math.floor(remainingSeconds / 60);
    const secs = Math.floor(remainingSeconds % 60);

    return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const formatDateWithTimeStamp = (timestamp) => {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sept',
        'Oct',
        'Nov',
        'Dec',
    ][date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day} ${month} ${year}, ${hours}:${minutes}:${seconds}`;
};

export const formatDateToYYYYMMDD = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${year}-${month}-${day}`;
};

export const copyToClipboard = async (data) => {
    await navigator.clipboard.writeText(data);
};

export const camelCaseToUpperCaseUnderscore = (str) => {
    if (!str || typeof str !== 'string') {
        return '';
    }

    return str
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
        .toUpperCase();
};
